import PrivacyNotice from "./privacyNoticeComponents";

export default PrivacyNotice;